<script setup lang="ts">
import { ref, watch } from 'vue'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import VehicleSelectDialog from '@/components/vehicle/VehicleSelectDialog.vue'
import { type Vehicle } from '@/types/Vehicle'

const modelValue = defineModel<Vehicle | null>()

const dialogVisible = ref(false)
const tagSearch = ref('')

watch(modelValue, (val) => {
  if (val?.tagNumber) tagSearch.value = val.tagNumber
})

function openDialog() {
  dialogVisible.value = true
}

function handleSelect(vehicle: Vehicle) {
  modelValue.value = vehicle
  tagSearch.value = vehicle.tagNumber
}
</script>

<template>
  <Card>
    <template #title>Vehicle</template>
    <template #content>
      <div class="space-y-4">
        <div class="flex gap-2 items-center">
          <InputText
            v-model="tagSearch"
            placeholder="Enter tag number"
            class="flex-1"
            @keydown.enter="openDialog"
          />
          <Button icon="pi pi-search" @click="openDialog" />
        </div>

        <div v-if="modelValue" class="text-sm text-gray-700 space-y-1">
          <div>
            <strong>Tag:</strong> {{ modelValue.tagNumber }}
            <span v-if="modelValue.state">({{ modelValue.state }})</span>
          </div>
          <div><strong>Year:</strong> {{ modelValue.year || '—' }}</div>
          <div><strong>Make:</strong> {{ modelValue.make || '—' }}</div>
          <div><strong>Model:</strong> {{ modelValue.model || '—' }}</div>
          <div><strong>Color:</strong> {{ modelValue.color || '—' }}</div>
          <div><strong>VIN:</strong> {{ modelValue.vin || '—' }}</div>
        </div>
      </div>

      <VehicleSelectDialog
        v-model="dialogVisible"
        @select="handleSelect"
        :search-prefill="tagSearch"
      />
    </template>
  </Card>
</template>
